import "./event.scss";
import VerifiedIcon from '@mui/icons-material/Verified';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Link } from "react-router-dom";
import Comments from "../comments/Comments";
import { useState } from "react";
import GeoEvent from "../geo/GeoEvent";
import OsintEvent from "../osint/OsintEvent";
const Event = ({ event }) => {
  const [commentOpen, setCommentOpen] = useState(false);

  //TEMPORARY
  const verified = false;

  if (event.event_type === "QUERY") {
    if (event.metadata.query_type === "GEOLOCATION" || event.metadata.query_type === "GEOFENCE") {
      if ('response' in event.metadata && event.metadata.response.length > 0) {
        const results = event.metadata.response;
        const posts = [];
        // for (const result of results) {//
        let targets = event.metadata.targets;
        for (let k = 0; k < results.length; k++) {
          try{
            const result = results[k];
            
            // We need to extract the target_id and target_name from the response using the phone number from result.response.msisdn
            const [target_id, target_name] = ((result, targets) => {
              for (let target of targets) {
                for (let phone of target.phone_numbers) {
                  if ((phone === result.msisdn) || (phone === `+${result.msisdn}`)) {
                    return [target.target_id, target.target_name];
                  }
                }
              }
              return [null, null];
            }).call(this, result, targets);
            let post = {
              id: event.id,
              status: 'Completed',
              target_id: target_id,
              target_name: target_name,
              timestamp: event.timestamp,
              msisdn: result.msisdn,
              imei: result.imei,
              imsi: result.imsi,
              operator: result.ported_network_name? result.ported_network_name: result.original_network_name,
              mcc: result.mcc,
              mnc: result.mnc,
              lac: result.lac,
              cellid: result.cellid,
              band: result.band,
              data: {
                location: {
                  lat: result.lat,
                  lng: result.lon,
                  radius: result.radius,
                  azimuth: result.azimuth,
                  reverse_geo: result.reverse_geo
              }
            }
            };
            console.log(post);
            posts.push(<GeoEvent post={post} key={k}/>);
          }catch(e){console.log(e);}
          
        }
        return posts;
      }
    } else if (event.metadata.query_type === "OSINT"){
      if ('response' in event.metadata && event.metadata.response.length > 0) {
        const results = event.metadata.response;
        const posts = [];
        // for (const result of results) {//
        let targets = event.metadata.targets;
        console.log("targets", targets);
        for (let k = 0; k < results.length; k++) {
          try{
            const result = results[k];
            
            // We need to extract the target_id and target_name from the response using the phone number from result.response.msisdn
            const [target_id, target_name] = ((result, targets) => {
              for (let target of targets) {
                for (let phone of target.phone_numbers) {
                  if ((phone === result.response.target_msisdn) || (phone === `+${result.target_msisdn}`)) {
                    return [target.target_id, target.target_name];
                  }
                }
              }
              return [null, null];
            }).call(this, result, targets);
            if ('msisdn' in result.response){
              result.response.target_msisdn = result.response.msisdn;
            }
            let post = { 
              title: event.title,
              details: event.details,
              status: 'Completed',
              event_id: event.id,
              target_id: target_id,
              target_name: target_name,
              timestamp: event.timestamp,
              msisdn: result.response.target_msisdn,
            };
            console.log(post);
            posts.push(<OsintEvent post={post} key={event.id + "_" + k}/>);
          }catch(e){console.log(e);}
          
        }
        return posts;
       
    }
    }
 } else if (event.event_type === "OSINT") {
    /*
    "metadata":{
      "lat": 24.416667,
      "lon": -118.483333,
      "date": "2021-10-08",
      "imei": "357863107448090",
      "time": "19:45:27",
      "radius": 100,
      "azimuth": "300",
      "target_A": "+522224074956",
      "target_B": "internet.itelcel.com",
      "event_type": "DATOS",
      "phone_number": "+522224074956",
      "reverse_geocoding": null
    }
    */
    const post = {
      title: `${event.metadata.event_type} - ${event.metadata.target_A} - ${event.metadata.target_B}`,
      details: event.details,
      status: 'Completed',
      timestamp: event.timestamp,
      metadata: event.metadata,
    };
    console.log(post);
    return (<GeoEvent post={post}/>);
  } 

  return (
    <div className="event">
      <div className="container">
        <div className="content">
          <p>{event.id}</p>
          <p>{event.title}</p>
          <p>{event.details}</p>
          <p>{event.status}</p>
          <p>{event.timestamp}</p>
          {/* <p>{event.metadata}</p> */}
        </div>
        <div className="info">
          <div className="item">
            {verified ? <VerifiedIcon /> : <VerifiedOutlinedIcon />}
            3 Verifications
          </div>
          <div className="item" onClick={() => setCommentOpen(!commentOpen)}>
            <TextsmsOutlinedIcon />
            12 Comments
          </div>
          <div className="item">
            <ShareOutlinedIcon />
            Share
          </div>
        </div>
        {commentOpen && <Comments />}
      </div>
    </div>
  );
};

export default Event;
